import { render, staticRenderFns } from "./paymentFail.vue?vue&type=template&id=16effd41&scoped=true"
import script from "./paymentFail.vue?vue&type=script&lang=js"
export * from "./paymentFail.vue?vue&type=script&lang=js"
import style0 from "./paymentFail.vue?vue&type=style&index=0&id=16effd41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16effd41",
  null
  
)

export default component.exports